import {useContext, useState, useEffect} from 'react'
import {ProductWiseReportContext} from '../../context'
import Search from '../../../../components/Search'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import MultipleSelect from '../../../../components/MultiSelect/MultiSelect'
import {ReachAsyncSelect} from '../../../../components/reachAsyncSelect'
import ExportCSVButton from '../../components/ExportCSVButton'
import {isEmpty} from '../../../../utils/common'
import { MIN_DATE_RANGE } from '../../utils'

const ProductWiseReportHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {
    onSearch,
    onDateChangeCustomers,
    onChangeClassificationFilter,
    onChangeSupplierFilter,
    onChangeProductFilter,
    classifications,
    suppliers,
    isClassificationsDropdownLoading,
    isSuppliersDropdownLoading,
    products,
    isProductsLoading,
    productsPagination,
    onProductsFilterPageChange,
    onProductsFilterSearch,
    onProductsFilterClassificationChange,
    onDownloadCSV,
    reportData,
    isLoading,
  } = useContext(ProductWiseReportContext)

  const [resetOptions, setResetOptions] = useState(false)

  const handleDateChange = (startDate: any, endDate: any) => {
    onDateChangeCustomers && onDateChangeCustomers(startDate, endDate)
  }

  const handleClassificationChange = (selectedOption: any) => {
    setResetOptions((prev) => !prev)
    onChangeClassificationFilter(selectedOption)
    onProductsFilterClassificationChange(selectedOption)
  }

  useEffect(() => {
    if (resetOptions) {
      setResetOptions(false)
    }
  }, [resetOptions])

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-end mb-10'>
      <div className='d-flex align-items-end gap-5 mb-5'>
        <Search
          onSearch={(searchTerm: string) => {
            onSearch && onSearch(searchTerm)
          }}
        />
        <MultipleSelect
          id={`classification-filter`}
          label='Classification'
          options={classifications}
          className='w-175px'
          placeholder='Select Classification'
          allValuesSelectedText={'Classification: All'}
          isLoading={isClassificationsDropdownLoading}
          handleSelected={handleClassificationChange}
        />
        <MultipleSelect
          id={`supplier-filter`}
          label='Supplier'
          options={suppliers}
          className='w-175px'
          placeholder='Select Supplier'
          allValuesSelectedText={'Supplier: All'}
          isLoading={isSuppliersDropdownLoading}
          handleSelected={onChangeSupplierFilter}
        />
        <ReachAsyncSelect
          id={'price-list-product'}
          label='Products'
          placeholder='Select Products'
          options={products}
          disabledKey='disabled'
          className='w-175px'
          isNullable={true}
          isLoading={isProductsLoading}
          onChange={onChangeProductFilter}
          onSearch={onProductsFilterSearch}
          selectClass={'react-select-multi-tags'}
          pagination={productsPagination}
          onPageChange={onProductsFilterPageChange}
          isMultiSelect={true}
          isResetOptions={resetOptions}
        />
      </div>
      <div className='d-flex gap-5 align-itens-end mb-5'>
        <ExportCSVButton
          onExportCSV={onDownloadCSV}
          isLoading={isLoading}
          hide={isEmpty(reportData)}
        />
        <div className='w-175px'>
          <PredefinedDateRange
            cb={handleDateChange}
            getLbl={() => {}}
            defaultValue={dateRangeLabel || 'Last 90 Days'}
            includeCurrantDay={true}
            startDate={MIN_DATE_RANGE}
          />
        </div>
      </div>
    </div>
  )
}

export default ProductWiseReportHeader
